import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {UserComponent} from '@components/administration/user/user.component';
import {AuthorizationGuardService} from '../../../shared/authorization-guard/authorization-guard.service';
import {USER_ROLE} from '@constants/user-role.constant';

const routes: Routes = [
  {path: '', redirectTo: '/login', pathMatch: 'full'},
  {
    path: 'users', component: UserComponent, canActivate: [AuthorizationGuardService],
    data: {roles: [USER_ROLE.USER, USER_ROLE.ANALYTICS, USER_ROLE.DISTRIBUTOR, USER_ROLE.ADMIN, USER_ROLE.TECH_ADMIN, USER_ROLE.SUPERADMIN]}
  }
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forRoot(routes)
  ]
})
export class UserRoutingModule {
}
